import { setDevisCookie, getCookie, checkNumber } from './functions';
/**
 * Click suppression d'un devis
 */
$("button[id^='devis_']").on('click', function(){
    // recupere l'id du devis clické
    let idDevis = getId($(this));

    // supprime le devis clické du DOM
    $(`#devisTr_${idDevis}`).remove();

    let cookieDevis = getCookie('devis');

    if(cookieDevis === null) return;

    cookieDevis = JSON.parse(cookieDevis);

    // supprime de la liste des cookies le cookie sur lequel on a cliqué
    let newCookieDevis = cookieDevis.filter((item) => item.id !== idDevis);

    // redefini le cookies
    document.cookie = setDevisCookie(newCookieDevis);

    deleteMessage();
    reduitPanierDevis();
});

/**
 * Click sur le bouton "mis à jour" du devis
 */
$('#update_devis').on('click', function(event){
    event.preventDefault();

    let cookieDevis = getCookie('devis');

    if(cookieDevis === null) return;

    cookieDevis = JSON.parse(cookieDevis);

    if(cookieDevis.length === 0) return;

    let devisValue = $("[name^='devis']");

    // met à jour les valeurs des produits
    let result = [];
    devisValue.each(function(index){
        cookieDevis.forEach( (cookieValues) => {
            
            // recupere l'id du devis
            let id = getId($(this));
            
            // si l'id du devis est différent à celui du cookie, passer a la prochaine itération
            if(cookieValues.id !== id) return;

            // redefini la valeur du devis
            let value = $(this).val();
            cookieValues = {...cookieValues, value: value };
            result.push(cookieValues);
        });
    });

    // redefini le cookies
    document.cookie = setDevisCookie(result);

    let message = getMessageUpdateDevis();
    if(message !== null) { addMessage(message); }
    
});

/**
 * Click sur le bouton "vider les devis"
 */
$('#empty_devis').on('click', function(event){
    event.preventDefault();

    // redefini le cookies
    document.cookie = setDevisCookie([]);

    // vide la liste des devis
    $('#devisContainer').empty();
    let message = getMessageEmptyDevis();

    $('.contenuPage').append(`
        <div class="container mt-4">
            <div class="alert alert-info" role="alert">
                ${message}
            </div>
        </div>
    `);
   
    resetPanierDevis();
});

// Sur click d'un champ text supprimer un message d'alterte d'une action précedente si il y en a
$("[name^='devis']").on('click', function(){
    deleteMessage();
});

/**
 * Empeche de saisir autre chose dans le champ de devis des fiches produit
 * Source: https://stackoverflow.com/questions/17209180/jquery-keyup-function-check-if-number
 */
$("[name^='devis']").on('keypress', checkNumber());


/**
 * Reduit le panier devis (l'icone en haut à droite)
 */
function reduitPanierDevis()
{
    let panierDevis = $('#panier-devis').text();

    // S'il n'y a pas de texte, ignorer
    if(panierDevis.length === 0) return;

    // Si la valeur du panier est de 1, supprimer le texte
    if(parseInt(panierDevis) === 1) { $('#panier-devis').text(''); return }

    // reduire la valeur du panier
    $('#panier-devis').text(parseInt(panierDevis) - 1);
}

function resetPanierDevis()
{
    $('#panier-devis').text('');
}

/**
 * Recupere l'id d'un element du devis, les id sont ecris de tel facon 'element_id", cette fonction permet de récupéré seulement l'id
 * @param {*JqueryDomElement} string 
 * @return {int}
 */
function getId(string)
{
    return parseInt(string.attr('id').split("_").pop());
}

/**
 * Ajoute un message (aletre bootstrap)
 * @param {string} message
 * @return {void}
 */
function addMessage(message){

	// verifie que un message n'est pas déjà présent dans le DOM
	if($('#messageDevis').length > 0) return

	// Ajoute le message
	$('#devisButtonBlock').after(
	`<div class="alert alert-info" role="alert" id="messageDevis">
		${message}
	  </div>`);
}

/**
 * Supprime un message (alerte bootstrap) précedement ajouté
 * @param {*string} message
 * @return {void}
 */
function deleteMessage(message){

	// verifie qu'il y a bien un message présent dans le DOM
	if($('#messageDevis').length === 0) return

	$('#messageDevis').remove();
}

/**
 * Recupere le message afficher sur la page lorsque le produit est mise à jour
 * Il est inseré dans le DOM afin de pouvoir le récupéré avec sa traduction
 * @return {string|null}
 */
function getMessageUpdateDevis()
{
    let messageData = $('.monDevis').data('message-maj');

    if(messageData.length === 0) return null;

    return messageData;
}

/**
 * Recupere le message afficher sur la page lorsque la liste des devie est vidé
 * Il est inseré dans le DOM afin de pouvoir le récupéré avec sa traduction
 * @return {string|null}
 */
function getMessageEmptyDevis()
{
    let messageData = $('.monDevis').data('message-empty');

    if(messageData.length === 0) return null;

    return messageData;
}